import { Box, CircularProgress, Skeleton, Typography } from '@mui/material'
import { ReactElement } from 'react'

type Props = {
  ibsc40Percent: number
  ibsc100Percent: number
  isLoading: boolean
}

let overlayBox = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
}

export default (props: Props): ReactElement => {
  let { ibsc40Percent, ibsc100Percent, isLoading } = props

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
        <Skeleton
          variant="circular"
          sx={{
            width: 200,
            height: 200,
          }}
        />
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        py: 2,
      }}
    >
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        {/* Outer track (grey background) */}
        <CircularProgress
          variant="determinate"
          value={100}
          size={200}
          thickness={4}
          sx={{ color: 'action.disabledBackground' }}
        />

        {/* IBSC 100 ring (orange/warning) — outer */}
        <Box sx={overlayBox}>
          <CircularProgress
            color="warning"
            variant="determinate"
            value={ibsc100Percent}
            size={200}
            thickness={4}
          />
        </Box>

        {/* Inner track (grey background) */}
        <Box sx={overlayBox}>
          <CircularProgress
            variant="determinate"
            value={100}
            size={152}
            thickness={4}
            sx={{ color: 'action.disabledBackground' }}
          />
        </Box>

        {/* IBSC 40 ring (green/success) — inner */}
        <Box sx={overlayBox}>
          <CircularProgress
            color="success"
            variant="determinate"
            value={ibsc40Percent}
            size={152}
            thickness={4}
          />
        </Box>

        {/* Center label */}
        <Box
          sx={{
            ...overlayBox,
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            color="primary.main"
            variant="h5"
            sx={{
              fontWeight: 700,
              lineHeight: 1.2,
            }}
          >
            IBSC
          </Typography>
          <Typography color="text.secondary" variant="caption">
            Progress
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
